var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showWebinarRegistrationButton)?_c('div',{staticClass:"material__register"},[_c('button',{class:[
      'material__register--btn',
      {'material__register--btn-disabled': _vm.haveUser}
    ],on:{"click":function($event){return _vm.$emit('openWebinarRegModal')}}},[_vm._v("\n    "+_vm._s(_vm.haveUser ? 'вы зарегистрированы' : 'зарегистрироваться')+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }